import { Eye, EyeOff, Sparkles } from "lucide-react";
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InputBox } from "../CommonComponents/InputBox";
import { SetSession } from '../CommonComponents/criptoUtils';
import Loader from './Loader';
import './LoginCSS.css';

export default function SignIn() {
    const StaticToken ='AmqCLI6rg7olYF5gNsde1eRE';
    const source = 'web';
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [user, setUser] = useState({ userCode: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const inputRefs = useRef([]);

    const handleLogin = async (event) => {

        event.preventDefault();
        setBtnLoading(true);
        const data = {
            Token: StaticToken,
            UserCode: user.userCode !== '' ? user.userCode : '0',
            Password: user.password,
            Source: source,
        };

        await fetch(`/api/UserLogin/Login`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(async (response) => {
                const res = await response.json();
                if (res.status === 'SUCCESS') {
                    await SetSession('cookies', 'user', res);
                    setIsLoading(true);
                    setTimeout(() => {
                        setIsLoading(false);
                        navigate(location.state || '/Dashboard/Index');
                    }, 1000);
                    localStorage.setItem('ID', '1');
                } else {
                    setBtnLoading(false);
                    toast.error(res.message, { position: 'top-center' });
                    inputRefs.current[res.focus]?.focus();
                }
            })
            .catch((err) => {
                setBtnLoading(false);
                toast.error(String(err), { position: 'top-center' });
            });
    };


    useEffect(() => {
        inputRefs.current['txtUserCode']?.focus();
    }, []);

    return (
        <>
           <div className="min-h-screen">
                <div className="grid grid-cols-1 md:grid-cols-3 min-h-screen">
                    <div className="col-span-2 relative bg-[var(--theme-color)] p-20">
                        <div className="absolute hidden md:block bottom-0 left-0 w-full">
                            <img src="/assets/img/Customer_logo_bg.png" alt='' className='w-full' />
                            <div className="absolute top-0 left-0 w-full h-full" style={{ background: "linear-gradient(to bottom, var(--theme-color), transparent)" }}>

                            </div>
                        </div>

                        <div className="relative z-10">
                            <span className="px-4 py-2 bg-white text-[var(--theme-color)] font-semibold rounded-full inline-flex items-center gap-2"><Sparkles width={16}/> Established in 2013</span>
                            <h1 className="text-white text-4xl font-bold mt-4">We’re Here To Build Something Great</h1>
                            <p className="text-white text-base mt-3">Patliputra Logistics has emerged as a prominent player in the supply chain industry, offering comprehensive solutions for first and last-mile delivery, transportation, fleet management, and supply chain and logistics advisory.</p>
                        </div>
                    </div>
                    <div>
                        <div className="w-full relative flex items-center justify-center px-6 py-12 overflow-hidden h-full">

                            {/* 🔥 Main Card */}
                            <div className="relative z-10 w-full max-w-md p-8 rounded-3xl">
                                <div className="mb-5">
                                    <img src="assets/img/patliputra_logo.png" className="w-[240px] mx-auto" alt="patliputra logo" />
                                </div>
                                {/* Heading */}
                                <div className="mb-8 text-center fade-up">
                                    <h2 className="text-4xl font-bold text-slate-800">Login</h2>
                                    <p className="text-slate-800 text-md mt-1 font-bold">
                                       Client Panel
                                    </p>
                                </div>

                                {/* Form */}
                                <form onSubmit={handleLogin} className="space-y-5">

                                    {/* User Code */}
                                    <InputBox
                                        id="txtUserCode"
                                        label="User Code"
                                        placeholder="Enter User Code"
                                        value={user.userCode}
                                        onChange={(e) =>
                                            setUser({ ...user, userCode: e.target.value })
                                        }
                                        inputrefs={inputRefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                inputRefs.current['txtPassword']?.focus();
                                            }
                                        }}
                                    />

                                    {/* Password */}
                                    <div className="relative">
                                        <InputBox
                                            id="txtPassword"
                                            label="Password"
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Enter Password"
                                            value={user.password}
                                            onChange={(e) =>
                                                setUser({ ...user, password: e.target.value })
                                            }
                                            inputrefs={inputRefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleLogin(e);
                                                }
                                            }}
                                        />

                                        {/* 👁 Eye Icon */}
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute right-3 top-[22px] cursor-pointer text-slate-400 hover:text-[var(--theme-color)]"
                                        >
                                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </span>
                                    </div>

                                    {/* Button */}
                                    <button className="w-full bg-[var(--theme-color)] hover:bg-sky-700 text-white py-2 rounded-xl">
                                        {btnLoading ? 'Logging in...' : 'Login'}
                                    </button>

                                </form>

                                {/* Footer */}
                                <p className="mt-8 text-center text-xs text-slate-400">
                                    © {new Date().getFullYear()} Patliputra Logistics · All rights reserved
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Loader */}
            {isLoading && (
                <Loader text='Welcome To Patliputra Logistics' size='100px' img_path='./images/favicon.png' /> 
            )}

            <ToastContainer />
        </>
    );
}